import React from "react";
import styles from "./Loader.module.css";

const Loader: React.FC<{ size: number; value: number }> = ({ size, value }) => {
  const [circleStyle, setCircleStyle] = React.useState({});

  React.useEffect(() => {
    const circumference = Math.PI * size;
    setCircleStyle({
      strokeDasharray: circumference.toFixed(3),
      strokeDashoffset: `${(((100 - value) / 100) * circumference).toFixed(
        3,
      )}px`,
    });
  }, [value]);

  return (
    <div className={styles.wrapper} style={{ width: size, height: size }}>
      <svg
        className={styles.svg}
        viewBox={`${size / 2} ${size / 2} ${size} ${size}`}
      >
        <circle
          className={styles.circle}
          style={circleStyle}
          cx={size}
          cy={size}
          r={size / 2}
          strokeWidth={size}
        />
      </svg>
    </div>
  );
};

export default Loader;
